import React from "react";
import { toast } from "sonner";
import { Flag } from "lucide-react";
import { api } from "../lib/api";

export const ReportButton = ({ payload, testid }) => {
  const send = async () => {
    if (!window.confirm("Segnalare questo messaggio all'amministratore?")) return;
    try {
      await api.report(payload);
      toast.success("Messaggio segnalato all'amministratore");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Segnalazione non riuscita");
    }
  };
  return (
    <button onClick={send} data-testid={testid} title="Segnala" className="text-slate-500 hover:text-[#ff9f1c]">
      <Flag className="w-3.5 h-3.5" />
    </button>
  );
};
